<template>
  <div class="home-page-wrapper content0-wrapper">
    <div class="bg"></div>
    <div class="content1 home-page">
      <div class="content5-list">
        <div 
          v-for="(item, index) in caseList" 
          :key="index"
          class="content5-list-item"
        >
          <div class="content5-list-item-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="content5-list-item-content">
            <div class="content5-list-item-content-p1">
              {{ item.abstract }}
            </div>
            <img :src="item.image" alt="" />
            <div class="content5-list-item-content-p2">
              相关解决方案
            </div>
            <div class="content5-list-item-content-p3">
              {{ item.caseTitle }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Img1 from '@/assets/case/case_1.png'
import Img2 from '@/assets/case/case_2.png'
import Img3 from '@/assets/case/case_3.png'
import Img4 from '@/assets/case/case_4.png'

export default {
  name: 'Content0',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'content0'
    }
  },
  data() {
    return {
      props: {},
      caseList: [
        {
          id: 1,
          createTime: "2024-08-14 17:25:57",
          updateTime: "2024-08-20 03:34:20",
          title: "陕西省安康市智慧治理指挥中心建设项目",
          abstract:
            "本项目搭建了智慧城市可视化服务系统、智能视觉感知系统、可视化指挥系统、智慧城市服务系统、网络安全系统、数字会议系统、指挥中心平台应用系统、数据治理系统等系统模块及设施，全面实现治理可视化、智能化。\n",
          image:Img1,
          subTitle: "相关解决方案",
          caseTitle: "城市智能运行可视化",
          url: "--",
        },
        {
          id: 2,
          createTime: "2024-08-14 19:26:43",
          updateTime: "2024-08-20 03:34:39",
          title: "通山县雪亮工程项目",
          abstract:
            "项目整合共享视频监控资源，服务公共安全实战需求，结合通山县公安视频监控建设实际，开展通山公安“雪亮工程”建设。到2020年，视频监控覆盖中心城区、城多社区、重点行业和领域，确保重点部位、重要场所的视监控覆盖率和联网率达到100％，实现“全域覆盖、全网共享、全时可用、全程可控”的总体目标。",
          image:Img2,
          subTitle: "相关解决方案",
          caseTitle: "公安大数据",
          url: "--",
        },
        {
          id: 3,
          createTime: "2024-08-14 19:27:55",
          updateTime: "2024-08-20 03:35:05",
          title: "黄冈市红安县竹林社区数字乡村项目",
          abstract:
            "本项目通过搭建数字乡村平台以及各类物联网设施，实现数字化、精细化管理，全面提升基层服务水平；辅助社区农业产业数字化升级，促进社区产业增收；改善人居环境，打造美丽宜居新乡村，让竹林社区走在乡村发展的前列。",
          image:Img3,
          subTitle: "相关解决方案",
          caseTitle: "数字乡村综合治理",
          url: "--",
        },
        {
          id: 4,
          createTime: "2024-08-14 19:28:58",
          updateTime: "2024-08-20 03:35:29",
          title: "福建省宁德市玛坑乡紫竹村数字乡村项目",
          abstract:
            "本项目从产业、人才、文化、生态、组织五大振兴目标出发，以服务政府、服务产业、服务群众为建设核心，通过建设数字化技术和运营，提升特色产品产业推广能力、提升经营主体经营服务能力、提升乡村管理服务综合水平，为紫竹村基层治理、产业发展及惠民服务提供数字化赋能，从而树立数字平台的标杆。",
          image:Img4,
          subTitle: "相关解决方案",
          caseTitle: "数字乡村综合治理",
          url: "--",
        },
      ],
    }
  },
  mounted() {
    // 初始化props
    this.props = { ...this.$props }
    delete this.props.dataSource
    delete this.props.isMobile
  }
}
</script>

<style scoped>
.content0-wrapper {
  width: 100%;
  overflow: hidden;
}

.content0-content {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.bg {
  width: 100%;
  height: 440px;
  background: url(@/assets/case_1.png) no-repeat center center / 100% 100%;
  z-index: -1;
}

.content1 {
  max-width: 1400px;
  margin: 0 auto;
  padding: 90px 20px 0;
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}

.content5-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 84px;
}

.content5-list-item {
  position: relative;
  width: 590px;
  height: 773px;
  background: #ffffff;
  border: 2px solid #eff3fc;
  border-radius: 8px;
  margin-bottom: 60px;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.15);
}

.content5-list-item-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 28px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #242934;
  width: 590px;
  height: 72px;
  background: linear-gradient(90deg, #eff3fc, #f4f5fd);
  border-radius: 8px 8px 0px 0px;
  span {
    margin-left: 56px;
  }
}


.content5-list-item-content {
  height: 100%;
  background: url(@/assets/quotation.png) no-repeat;
  background-position: 430px 54px;
  background-size: 110px 110px;
  position: relative;
}

.content5-list-item-content img {
  position: absolute;
  left: 60px;
  top: 188px;
  object-fit: cover;
}

.content5-list-item-content-p1 {
  margin-top: 26px;
  margin-left: 56px;
  width: 474px;
  font-size: 14px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #242934;
  line-height: 28px;
}

.content5-list-item-content-p2 {
  position: absolute;
  left: 60px;
  bottom: 200px;
  width: 96px;
  font-size: 16px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: bold;
  color: #242934;
  line-height: 28px;
}

.content5-list-item-content-p3 {
  position: absolute;
  left: 60px;
  bottom: 145px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 156px;
  height: 34px;
  background: #f2f3f7;
  font-size: 14px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #0a79f7;
}

.copyright-wrapper {
  margin-top: 60px;
  padding: 20px;
  background-color: #333;
}

.copyright {
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.copyright a {
  color: #fff;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}

.content2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 90px;
  margin-bottom: 175px;
  width: 197px;
  height: 49px;
  border: 1px solid #c6d5e2;
  border-radius: 2px;
  font-size: 18px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #a3b7c9;
  margin: 0 auto 175px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content0-content {
    padding: 60px 20px;
  }

  .content1 {
    padding: 60px 20px 0;
  }

  .content5-list {
    margin-top: 60px;
  }

  .content5-list-item {
    width: 100%;
    height: auto;
    min-height: 600px;
  }

  .content5-list-item-title {
    width: 100%;
    font-size: 24px;
  }

  .content5-list-item-title span {
    font-size: 20px;
  }

  .content5-list-item-content {
    height: auto;
    padding: 20px;
    background: none;
  }

  .content5-list-item-content img {
    position: static;
    width: 100%;
    height: auto;
    margin: 20px 0;
  }

  .content5-list-item-content-p1 {
    margin: 0 0 20px 0;
    width: 100%;
  }

  .content5-list-item-content-p2 {
    position: static;
    margin: 20px 0;
    text-align: center;
  }

  .content5-list-item-content-p3 {
    position: static;
    margin: 20px 0;
    width: 100%;
  }

  .content2 {
    margin: 60px auto 120px;
  }
}
</style>